import { Box, Grid, Tabs, Tab, Typography } from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import MainButton from "src/components/buttons/mainbutton";
import SecondaryButton from "src/components/buttons/secondbutton";
import { InnerContentBox } from "src/components/ContentBox/ContentBox";
import { nomad } from "src/media/texts/infotabs/nomad";
import { studentInfo } from "src/media/texts/infotabs/student";
import { vacation } from "src/media/texts/infotabs/vacation";
import { tabStyle } from "src/pages/UserHome";
import { textStyle } from "src/styles/textstyle";

export default function InfoTabs({}) {
  const [activeTab, setActiveTab] = useState<number | null>(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const tabs = [
    { label: "Student", mobileLabel: "Student", content: studentInfo },
    { label: "Digital Nomad", mobileLabel: "Nomad", content: nomad },
    { label: "Vacation", mobileLabel: "Vacation", content: vacation },
  ];

  const buttonSx = {
    width: { xs: "100%", sm: "auto" },
    fontSize: { xs: "0.7rem", sm: "0.9rem" },
    px: { xs: 1.5, sm: 3 },
    py: { xs: 0.75, sm: 1.2 },
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  };

  const tabSx = {
    ...tabStyle,
    fontSize: { xs: "2.0rem", sm: "0.9rem" },
    minWidth: 0,
    flex: isMobile ? 1 : "0 0 auto",
    width: { xs: "100%", sm: "auto" },
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          paddingTop: 2,
          paddingBottom: 5,
        }}
      >
        <Box sx={{ width: "95%", minHeight: 0 }}>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 600,
              mb: 3,
              textAlign: "left",
              ...textStyle,
            }}
          >
            Who is HomeSwap for?
          </Typography>
          <Tabs
            value={activeTab ?? false}
            variant={isMobile ? "fullWidth" : "standard"}
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              width: "100%",
              "& .MuiTabs-flexContainer": {
                flexWrap: "nowrap",
                justifyContent: isMobile ? "space-between" : "flex-start",
              },
              "& .MuiTabs-indicator": {
                display: "none", // hide the sliding indicator
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                key={tab.label}
                label={
                  activeTab === index ? (
                    <MainButton
                      text={isMobile ? tab.mobileLabel : tab.label}
                      sx={buttonSx}
                    />
                  ) : (
                    <SecondaryButton
                      text={isMobile ? tab.mobileLabel : tab.label}
                      sx={buttonSx}
                    />
                  )
                }
                onClick={() =>
                  setActiveTab((prev) => (prev === index ? null : index))
                }
                sx={tabSx}
              />
            ))}
          </Tabs>
          {activeTab !== null && (
            <InnerContentBox
              sx={{ pt: 2, mt: 2, overflow: "visible", height: "auto" }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <Typography
                    variant="body1"
                    sx={{ pb: 2, whiteSpace: "pre-line" }}
                  >
                    {tabs[activeTab].content}
                  </Typography>
                </Grid>
              </Grid>
            </InnerContentBox>
          )}
        </Box>
      </Box>
    </>
  );
}
